module.exports = __webpack_public_path__ + "img/IMG-20200705-WA0009.984fd2ef.jpg";